module.exports = __webpack_public_path__ + "img/6_93.e5b9beab.png";